/* Info popup drawer: reset scroll to top on every open. Added by Oleg @ IAKOE.
   The kit ia-drawer keeps its scroll position between opens; we listen for its
   'ia-drawer-opened' event (non-bubbling, so a capture-phase document listener
   catches it) and scroll our drawer back to the top. One listener for all
   ts-info-drawer instances; guarded so multiple blocks don't double-bind. */
(function () {
  if (window.__tsInfoPopupInit) return;
  window.__tsInfoPopupInit = true;

  document.addEventListener('ia-drawer-opened', function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains('ts-info-drawer')) return;
    var win = d.querySelector('[data-drawer-window]');
    if (win) win.scrollTop = 0;
    var inner = d.querySelector('.ia-drawer__inner');
    if (inner) inner.scrollTop = 0;

    // Promote the deferred image on first open (markup ships src/srcset in data-*
    // so a closed drawer costs zero bytes).
    var imgs = d.querySelectorAll('img[data-src], img[data-srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
      if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
    }
  }, true);
})();
